import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/authService';
import { demoAuthService } from '../../services/demoAuthService';
import { isDemoMode } from '../../config';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAdmin = false 
}) => {
  const isAuthenticated = authService.isAuthenticated();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check admin requirement for demo mode
  if (isDemoMode && requireAdmin) {
    const isAdmin = demoAuthService.isAdmin();
    if (!isAdmin) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};